import { createContext, useContext, useMemo, useState } from 'react';
import { noop } from 'lodash';

const initialState = {
  closeFarmSettingsModal: noop,
  currentFarmSettingsModalId: null,
  farmRefetchQuery: null,
  openSettingsModalForFarm: noop,
};

const FarmSettingsContext = createContext(initialState);

export const FarmSettingsContextProvider = ({ children }) => {
  const [currentFarmSettingsModalId, setCurrentFarmSettingsModalId] = useState(
    initialState.currentFarmSettingsModalId,
  );
  const [farmRefetchQuery, setFarmRefetchQuery] = useState(
    initialState.farmRefetchQuery,
  );
  const value = useMemo(
    () => ({
      currentFarmSettingsModalId,
      openSettingsModalForFarm: (farmId, refetchQuery = null) => {
        setCurrentFarmSettingsModalId(farmId);
        setFarmRefetchQuery(refetchQuery);
      },
      closeFarmSettingsModal: () => {
        setCurrentFarmSettingsModalId(null);
        setFarmRefetchQuery(null);
      },
      farmRefetchQuery,
    }),
    [currentFarmSettingsModalId, farmRefetchQuery],
  );

  return (
    <FarmSettingsContext.Provider value={value}>
      {children}
    </FarmSettingsContext.Provider>
  );
};

export const useFarmSettingsContext = () => useContext(FarmSettingsContext);
